import ControlFactory from '@/Factories/ControlFactory';
import ComponentManger from '@/Management/ComponentManager';
import PasswordBoxViewModel from '@/ViewModels/Controls/PasswordBoxViewModel';
import PasswordBox from '@/Controls/PasswordBox';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class PasswordBoxFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private PasswordBoxViewModel = ComponentManger.getViewModel<typeof PasswordBoxViewModel>('PasswordBoxViewModel');
    private PasswordBox = ComponentManger.getControl<typeof PasswordBox>('PasswordBox');
    protected LabelViewModel = ComponentManger.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: PasswordBoxViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: PasswordBox;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.createViewModel();

        this.control = new this.PasswordBox(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    private createViewModel(): PasswordBoxViewModel {
        let length = this.detailViewItem.length;
        if (isNaN(length) || length === 0) {
            length = 255;
        }

        return new this.PasswordBoxViewModel({
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name,
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            maxLength: length
        })
    }

}

ComponentManger.setFactory('PasswordBox', PasswordBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');